import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {liteTemplate} from "@/lib/routes";

const defaultSetRoute = {
    shipment: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipment', route);
            return false;
        }
        router.push({
            name: consts.routerNames?.shipment.main,
            params: {},
            query: {...route.query}
        })
    },
    shipmentId: (route, router, shipmentId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipmentId', route);
            return false;
        }

        let query = route.query;
        let shipments = store.getters.getShipments
            .filter(s =>
                (
                    query.status === 'completed' ?
                        consts?.shipment?.extendedShipmentByStatus?.includes(s.status) :
                        !consts?.shipment?.extendedShipmentByStatus?.includes(s.status)
                )
                && s.id
            )
            .map(s => s.id);

        if(shipments.includes(shipmentId)) {
            let localeStorageKey = store.getters.getUserStorageKey + '.shipmentId'
            localStorage.setItem(localeStorageKey, shipmentId)
        }

        router.push({
            name: consts.routerNames?.shipment.id,
            params: {
                shipmentId,
            },
            query,
        })
    },
    shipmentEditSetActiveTab: (route, router, shipmentId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipmentEdit', route);
            return false;
        }

        router.push({
            name: route.name,
            params: {
                ...route.params,
                shipmentId,
            },
            query: {...route.query}
        })
    },
    shipmentEditView: (route, router, shipmentId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipmentEdit', route);
            return false;
        }

        let shipment = store.getters.getShipmentsById[shipmentId]
        if(shipment?.package_id) {
            router.push({
                name: consts.routerNames.shipment.packageIdEdit,
                params: {
                    ...route.params,
                    packageId: shipment.package_id,
                    shipmentId: shipmentId || -1,
                },
                query: {...route.query}
            })
        } else {
            router.push({
                name: consts.routerNames.shipment.editView,
                params: {
                    ...route.params,
                    shipmentId,
                },
                query: {...route.query}
            })
        }
    },
    shipmentEditPackage: (route, router, packageId, shipmentId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipmentEdit', route);
            return false;
        }

        let shipments = store.getters.getShipmentsByPackageId[packageId] || []
        shipmentId = shipmentId || shipments[0]?.id

        router.push({
            name: consts.routerNames.shipment.packageIdEdit,
            params: {
                ...route.params,
                packageId,
                shipmentId: shipmentId || -1,
            },
            query: {...route.query}
        })
    },
    shipmentTrackPoint: (route, router, shipmentTrackPoint) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipmentTrackPoint', route);
            return false;
        }

        router.push({
            name: route.name,
            params: {
                ...route.params,
                shipmentTrackPoint,
            },
            query: {...route.query}
        })
    },
    shipmentSwitch: (route, router, shipmentId, routeName) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipmentId', route);
            return false;
        }
        router.push({
            name: routeName,
            params: {
                ...route.params,
                shipmentId,
            },
            query: {...route.query}
        })
    },
    returnToParent:(route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn(consts.routerNames.shipment.main+' returnToParent', route);
            return false;
        }

        let localeStorageKey = store.getters.getUserStorageKey + '.shipmentId'
        let shipmentId = localStorage.getItem(localeStorageKey)
        let shipments = store.getters.getShipments.filter(s => !consts?.shipment?.extendedShipmentByStatus?.includes(s.status) && s.id);
        let shipment = shipments.find(s => s.shipmentId == shipmentId) || shipments[0]
        shipmentId = shipment?.id
        let name = route.meta?.parentRouteName || consts.routerNames.shipment.main;

        router.push({
            name: name,
            params: {
                ...route.params,
                shipmentId,
                edit: route?.params?.edit ? null : 'edit'
            },
            query: {...route.query}
        })
    },
    shipmentFilter: (route, router, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.shipment.main) {
            if(consts.app.$isDevelopment) console.warn('shipmentFilter', route);
            return false
        }
        router.push({
            name: route.name,
            params: {
                ...route.params
            },
            query: {
                ...filter
                // name: filter?.name || undefined,
                // type: filter?.type || undefined,
                // mode: filter?.mode || undefined,
            }
        })
    },
    liteTemplate,
}

const routes = (process.env.VUE_APP_PACKAGE !== 'intuit.portal') ? [] : [
    {
        path: 'shipment/:pathMatch(.*)?/:noList(no-list)?',
        name: consts.routerNames.shipment.main,
        meta: {
            list: "ShipmentList",
            mainRouteName: consts.routerNames.shipment.main,
            pageLayout: 'shipment',
            showMap: true,
            weatherInMap: true,
            mapType: 'Google-Hybrid',
            unitTracking: true,
            layers: {
                ...consts.defaultSettingsLayers,
                shipments_tracks: {visible: true, showInList: false, showLayer: true},
                shipments_units: {visible: true, showInList: false, showLayer: true},
            },
            setRoute: defaultSetRoute,
        },
        props: {
            default: (route) => ({
                shipmentId: route?.params?.shipmentId
            })
        },
        components: {
            default: () => import('@/views/intuit/portal/ShipmentPage.vue')
        },
        children: [
            {
                path: ':shipmentId(\\d+)/:shipmentTrackPoint(start|end)?',
                name: consts.routerNames.shipment.id,
                meta: {
                    mainRouteName: consts.routerNames.shipment.main,
                    parentRouteName: consts.routerNames.shipment.id,
                    pageClass: 'shipment__view',
                    weatherInMap: true,
                },
                props: {
                    default: (route) => ({
                        shipmentId: route.params.shipmentId
                    }),
                },
                components: {
                    default: () => import('@/components/shipment/ShipmentView.vue'),
                },
                children: [
                    {
                        path: 'map',
                        name: consts.routerNames.shipment.map,
                        meta: {
                            mainRouteName: consts.routerNames.shipment.main,
                            parentRouteName: consts.routerNames.shipment.id,
                            pageClass: 'shipment__view shipment__map',
                            weatherInMap: true,
                        },
                    },
                ]
            },
            {
                path: ':packageId(\\d+)',
                name: consts.routerNames.shipment.packageId,
                meta: {
                    mainRouteName: consts.routerNames.shipment.main,
                    parentRouteName: consts.routerNames.shipment.groupId,
                    pageClass: 'shipment__view',
                    weatherInMap: true,
                },
                props: {
                    default: (route) => ({
                        groupId: route.params.groupId
                    }),
                },
                components: {
                    default: () => import('@/components/shipment/ShipmentView.vue'),
                },
                children: [
                    {
                        path: 'map',
                        name: consts.routerNames.shipment.packageMap,
                        meta: {
                            mainRouteName: consts.routerNames.shipment.main,
                            parentRouteName: consts.routerNames.shipment.groupId,
                            pageClass: 'shipment__view shipment__map',
                            weatherInMap: true,
                            sectionInfoByRoute: (route) => {
                                return !!route?.params?.edit
                            },
                        },
                        props: {
                        },
                        components: {
                        },
                        children: [
                        ]
                    },
                ]
            },
            {
                path: 'edit/:shipmentId(\\d+)',
                name: consts.routerNames.shipment.editView,
                meta: {
                    list: false,
                    mainRouteName: consts.routerNames.shipment.main,
                    blockingRoutesTransitionFromOutside: true,
                    pageClass: 'shipment__view-edit',
                },
                props: {
                    default: (route) => ({
                        shipmentId: route?.params?.shipmentId,
                        shipmentActiveId: route?.params?.shipmentActiveId
                    })
                },
                components: {
                    default: () => import('@/components/shipment/sectionInfo/ShipmentEdit.vue'),
                },
            },
            {
                path: 'edit/:packageId(\\d+)/:shipmentId(\\d+)',
                name: consts.routerNames.shipment.packageIdEdit,
                meta: {
                    list: false,
                    mainRouteName: consts.routerNames.shipment.main,
                    blockingRoutesTransitionFromOutside: true,
                    pageClass: 'shipment__view-edit',
                },
                props: {
                    default: (route) => ({
                        packageId: route?.params?.packageId,
                        shipmentId: route?.params?.shipmentId
                    })
                },
                components: {
                    default: () => import('@/components/shipment/sectionInfo/ShipmentEditPackage.vue'),
                },
            },
        ]
    },
];

export default routes;